import "./App.css";
import React from "react";
import Allroutes from "./routes/Allroutes";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";

const App = () => {
  // useEffect(() => {
  //   const disableRightClick = (event) => event.preventDefault();
  //   const disableDevTools = (event) => {
  //     if (
  //       event.keyCode === 123 ||
  //       (event.ctrlKey && event.shiftKey && event.keyCode === 73) ||
  //       (event.ctrlKey && event.keyCode === 85) ||
  //       (event.ctrlKey && event.shiftKey && event.keyCode === 74) ||
  //       (event.metaKey && event.shiftKey && event.keyCode === 73) ||
  //       (event.metaKey && event.keyCode === 85) ||
  //       (event.metaKey && event.shiftKey && event.keyCode === 74)
  //     ) {
  //       event.preventDefault();
  //     }
  //   };

  //   document.addEventListener("contextmenu", disableRightClick);
  //   document.addEventListener("keydown", disableDevTools);

  //   return () => {
  //     document.removeEventListener("contextmenu", disableRightClick);
  //     document.removeEventListener("keydown", disableDevTools);
  //   };
  // }, []);
  return (
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#114598",
            colorLink: "#114598",
            borderRadius: 12,
            fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
          },
        }}
      >
        <Allroutes />
      </ConfigProvider>
    </BrowserRouter>
  );
};

export default App;
